<div class="wrapper-page reservations-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Rezervacije i kupljeni pokloni</span>
      <!--      <button class="zc-btn zc-btn&#45;&#45;primary"><span>Dodaj</span></button>-->
    </div>
    <div class="zc-wrapper-tabs">
      <div class="zc-tab" (click)="activeTab = ReservationsTabsEnums.reservations" [ngClass]="{'active': activeTab === ReservationsTabsEnums.reservations}">
        <div class="wrapper-tab-notification">
          <span>Rezervacije</span>
          <span *ngIf="reservationsNotificationsCount" class="more-notification">{{reservationsNotificationsCount}}</span>
        </div>
      </div>
      <div class="zc-tab" (click)="activeTab = ReservationsTabsEnums.boughtGifts" [ngClass]="{'active': activeTab === ReservationsTabsEnums.boughtGifts}">
        <div class="wrapper-tab-notification">
          <span>Kupljeni pokloni</span>
          <span *ngIf="giftsNotificationsCount" class="more-notification">{{giftsNotificationsCount}}</span>
        </div>
      </div>
      <div class="zc-tab" (click)="activeTab = ReservationsTabsEnums.forDeliveries" [ngClass]="{'active': activeTab === ReservationsTabsEnums.forDeliveries}">
        <span>Za dostavljača</span>
      </div>
    </div>
    <gr-reservations-tab [hidden]="activeTab !== ReservationsTabsEnums.reservations" (reservationsNotificationsCount)="reservationsNotificationsCount = $event" [reservationsCount]="giftsNotificationsCount"></gr-reservations-tab>
    <gr-bought-gifts-tab [hidden]="activeTab !== ReservationsTabsEnums.boughtGifts" (giftsNotificationsCount)="giftsNotificationsCount = $event" [giftsUnreadCount]="giftsNotificationsCount"></gr-bought-gifts-tab>
    <gr-for-deliveries-tab [hidden]="activeTab !== ReservationsTabsEnums.forDeliveries"></gr-for-deliveries-tab>
  </div>
</div>
